export const vi = {
  "app.title": "survivrr.io",
  "menu.online": "Trực tuyến",
  "menu.offline": "Ngoại tuyến",
  "menu.play": "Chơi",
  "menu.name": "Tên",
  "menu.ballColor": "Màu bóng",
  "menu.nameColor": "Màu tên",
  "menu.moreInfo": "Thông tin thêm",
  "menu.moreInfoTitle": "Thông tin thêm",
  "menu.moreInfoSubtitle": "Trang pháp lý, chi tiết cookie và thông tin liên hệ.",
  "menu.back": "Quay lại",
  "menu.privacySettings": "Cài đặt quyền riêng tư",
  "menu.cookiePolicy": "Chính sách cookie",
  "menu.privacyPolicy": "Chính sách quyền riêng tư",
  "menu.termsOfService": "Điều khoản dịch vụ",
  "menu.emailButton": "Gửi e-mail",
  "menu.websiteButton": "Xem trang web của tôi",
  "menu.contactEmailLabel": "E-mail liên hệ:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Xem trang web của tôi:",
  "menu.nameRequired": "Hãy nhập tên trước.",
  "moreInfo.privacySettings.intro1": "Bạn có thể quản lý lựa chọn quyền riêng tư trên trang này thông qua thông báo đồng ý do nhà cung cấp quảng cáo hiển thị khi có sẵn.",
  "moreInfo.privacySettings.intro2": "Bạn cũng có thể kiểm soát cookie và bộ nhớ cục bộ trong cài đặt trình duyệt bất cứ lúc nào.",
  "moreInfo.privacySettings.adsHeading": "Kiểm soát quảng cáo",
  "moreInfo.privacySettings.adsParagraph": "Một số quảng cáo có thể do Google hoặc các đối tác khác cung cấp. Lựa chọn quảng cáo cá nhân hóa cũng có thể được quản lý trực tiếp trong cài đặt quảng cáo của Google.",
  "moreInfo.privacySettings.adsBullet1": "Mở phần kiểm soát quảng cáo của Google tại myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Xóa cookie hoặc dữ liệu trang nếu bạn muốn đặt lại lựa chọn đồng ý.",
  "moreInfo.privacySettings.adsBullet3": "Dùng cài đặt quyền riêng tư của trình duyệt để chặn hoặc giới hạn cookie.",
  "moreInfo.privacySettings.localHeading": "Cài đặt cục bộ",
  "moreInfo.privacySettings.localParagraph": "Trò chơi này lưu các tùy chọn cục bộ cơ bản như tên người chơi, màu sắc, tùy chọn âm thanh và ngôn ngữ để trang có thể ghi nhớ trên thiết bị của bạn.",
  "moreInfo.cookiePolicy.intro1": "Trang này dùng cookie và các công nghệ lưu trữ tương tự để chạy trò chơi, ghi nhớ cài đặt của bạn và hỗ trợ quảng cáo.",
  "moreInfo.cookiePolicy.intro2": "Cookie cũng có thể được dùng để đo lường, chống gian lận và cá nhân hóa quảng cáo tùy theo lựa chọn đồng ý và các dịch vụ được bật trên trang.",
  "moreInfo.cookiePolicy.typesHeading": "Các loại cookie và lưu trữ chúng tôi có thể dùng",
  "moreInfo.cookiePolicy.typeBullet1": "Lưu trữ thiết yếu để giữ cho trang hoạt động.",
  "moreInfo.cookiePolicy.typeBullet2": "Lưu trữ tùy chọn để ghi nhớ tên, màu sắc, ngôn ngữ và cài đặt âm thanh.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookie quảng cáo hoặc đo lường do các đối tác quảng cáo như Google dùng khi quảng cáo được bật.",
  "moreInfo.cookiePolicy.manageHeading": "Cách quản lý cookie",
  "moreInfo.cookiePolicy.manageParagraph": "Bạn có thể quản lý cookie qua thông báo đồng ý trên trang khi có sẵn, hoặc qua cài đặt trình duyệt. Tắt một số cookie có thể ảnh hưởng đến tính năng của trang hoặc việc hiển thị quảng cáo.",
  "moreInfo.privacyPolicy.intro1": "Trang này là trò chơi trình duyệt do Michał Kierzkowski vận hành. Chúng tôi cố gắng thu thập ít thông tin cá nhân nhất có thể.",
  "moreInfo.privacyPolicy.intro2": "Không cần tài khoản để chơi. Trò chơi có thể lưu tùy chọn cục bộ cơ bản trên thiết bị của bạn và xử lý dữ liệu chơi cần thiết cho các trận trực tuyến.",
  "moreInfo.privacyPolicy.infoHeading": "Thông tin chúng tôi có thể xử lý",
  "moreInfo.privacyPolicy.infoBullet1": "Tên người chơi bạn chọn và cài đặt ngoại hình.",
  "moreInfo.privacyPolicy.infoBullet2": "Dữ liệu phiên cơ bản cần thiết để vận hành tính năng nhiều người chơi.",
  "moreInfo.privacyPolicy.infoBullet3": "Dữ liệu thiết bị, trình duyệt hoặc quảng cáo do đối tác phân tích hoặc quảng cáo thu thập nếu các dịch vụ đó được bật.",
  "moreInfo.privacyPolicy.useHeading": "Cách chúng tôi dùng thông tin",
  "moreInfo.privacyPolicy.useBullet1": "Để vận hành trò chơi và phòng trực tuyến.",
  "moreInfo.privacyPolicy.useBullet2": "Để ghi nhớ cài đặt trên thiết bị của bạn.",
  "moreInfo.privacyPolicy.useBullet3": "Để cải thiện hiệu suất, bảo mật và độ ổn định.",
  "moreInfo.privacyPolicy.useBullet4": "Để hiển thị quảng cáo khi quảng cáo được bật.",
  "moreInfo.privacyPolicy.contactHeading": "Liên hệ",
  "moreInfo.privacyPolicy.contactParagraph1": "Nếu bạn có câu hỏi về quyền riêng tư, hãy liên hệ: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Trang web: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Bằng cách sử dụng trang này, bạn đồng ý dùng trò chơi một cách hợp pháp và công bằng.",
  "moreInfo.terms.intro2": "Trò chơi được cung cấp nguyên trạng và có thể thay đổi, gián đoạn hoặc bị gỡ bỏ bất cứ lúc nào.",
  "moreInfo.terms.rulesHeading": "Quy tắc",
  "moreInfo.terms.ruleBullet1": "Không lạm dụng lỗi, cheat, tự động hóa hoặc khai thác lỗ hổng.",
  "moreInfo.terms.ruleBullet2": "Không cố gây hại cho dịch vụ hoặc người chơi khác.",
  "moreInfo.terms.ruleBullet3": "Không dùng tên hoặc nội dung xúc phạm, bất hợp pháp hoặc gây hiểu lầm.",
  "moreInfo.terms.limitationHeading": "Giới hạn",
  "moreInfo.terms.limitationParagraph": "Trong phạm vi tối đa luật pháp cho phép, chúng tôi không chịu trách nhiệm về mất mát, gián đoạn hoặc thiệt hại phát sinh từ việc sử dụng trang.",
  "moreInfo.terms.changesHeading": "Thay đổi",
  "moreInfo.terms.changesParagraph": "Các điều khoản này có thể được cập nhật trong tương lai. Tiếp tục dùng trang sau khi cập nhật nghĩa là bạn chấp nhận điều khoản đã cập nhật.",
  "status.offline": "Đang bắt đầu trận ngoại tuyến...",
  "status.connecting": "Đang kết nối tới máy chủ...",
  "queue.title": "Đang chờ phòng",
  "queue.menu": "Quay lại menu chính",
  "game.pressToMove": "Nhấn bất kỳ đâu để di chuyển",
  "game.touchToMove": "Chạm bất kỳ đâu để di chuyển",
  "game.leaderboard": "Bảng xếp hạng",
  "game.hp": "HP",
  "game.level": "Cấp",
  "game.xp": "XP",
  "game.respawning": "Đang hồi sinh...",
  "gameEnd.title": "Kết thúc game",
  "gameEnd.winTitle": "Bạn thắng",
  "gameEnd.subtitle": "Trận đấu đã kết thúc. Hồi sinh để bắt đầu vòng tiếp theo hoặc quay lại menu.",
  "pause.title": "Menu game",
  "pause.resume": "Tiếp tục",
  "pause.menu": "Quay lại menu chính",
  "upgrade.title": "Chọn nâng cấp",
  "upgrade.generic.title": "Nâng cấp",
  "upgrade.generic.description": "Cải thiện build của bạn.",
  "upgrade.newWeaponPrefix": "Vũ khí mới:",
  "upgrade.stat.maxHp.title": "HP tối đa",
  "upgrade.stat.maxHp.description": "Tăng HP tối đa.",
  "upgrade.stat.speed.title": "Tốc độ di chuyển",
  "upgrade.stat.speed.description": "Tăng tốc độ di chuyển.",
  "upgrade.stat.generic.title": "Nâng cấp chỉ số",
  "upgrade.stat.generic.description": "Cải thiện chỉ số của bạn.",
  "upgrade.weapon.projectileShot.title": "Bắn đạn",
  "upgrade.weapon.projectileShot.description": "Thêm bắn đạn vào build của bạn.",
  "upgrade.weapon.orbitingBalls.title": "Bóng quỹ đạo",
  "upgrade.weapon.orbitingBalls.description": "Thêm bóng quỹ đạo vào build của bạn.",
  "upgrade.weapon.damageZone.title": "Vùng sát thương",
  "upgrade.weapon.damageZone.description": "Thêm vùng sát thương quanh nhân vật.",
  "upgrade.weapon.generic.title": "Vũ khí",
  "upgrade.weapon.generic.description": "Thêm vũ khí này vào build của bạn.",
  "upgrade.weaponUpgrade.frequency.title": "Tần suất",
  "upgrade.weaponUpgrade.frequency.description": "Tấn công thường xuyên hơn.",
  "upgrade.weaponUpgrade.range.title": "Tầm",
  "upgrade.weaponUpgrade.range.description": "Tăng tầm vũ khí.",
  "upgrade.weaponUpgrade.projectileCount.title": "Số lượng đạn",
  "upgrade.weaponUpgrade.projectileCount.description": "Tạo nhiều đạn hơn.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Tốc độ đạn",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Làm đạn bay nhanh hơn.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Tốc độ quỹ đạo",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Làm bóng quỹ đạo quay nhanh hơn.",
  "upgrade.weaponUpgrade.damage.title": "Sát thương",
  "upgrade.weaponUpgrade.damage.description": "Gây nhiều sát thương hơn.",
  "upgrade.weaponUpgrade.generic.title": "Nâng cấp vũ khí",
  "upgrade.weaponUpgrade.generic.description": "Cải thiện vũ khí này.",
  "defeat.title": "Thất bại",
  "defeat.subtitle": "Hồi sinh hoặc quay lại menu",
  "defeat.respawn": "Hồi sinh",
  "defeat.menu": "Menu chính",
  "error.generic": "Đã xảy ra lỗi.",
} as const;
